export { default } from './shipping-item';